import { Fragment } from 'react';
import LocationPicker from '../ReadingHabitsImportantCities/LocationPicker/LocationPicker';
import './StudentInvited.scss';

const variable = 'placesOfInterest';

export default function StudentInvitedImportantCities({
  model,
  onUpdate,
  onValidate,
  onContinue,
}) {
  return (
    <div className="student-invited-important-cities">
      <div className="shell">
        <div className="step-eyebrow">Step 2 of 4</div>
        <h1 className="step-h1">Local reading</h1>
        <p className="step-sub">
          What cities and/or towns are important to you?
        </p>

        <div className="question-description">
          Every week, your AverPoint goals will include some local reading. What
          cities or towns do you follow?
        </div>

        <div className="location-section">
          <LocationPicker
            onChange={(val) => {
              onUpdate({ ...model, [variable]: val });
            }}
            value={model[variable]}
          />
        </div>

        <button
          type="button"
          className="btn-primary"
          onClick={async () => {
            await onContinue();
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
}
